<template>

    <div class="tab-pane fade" id="modalitaPagamento" role="tabpanel">
        <h5 class="label-bar"><i class="ph-credit-card me-1"></i> Modalita di Pagamento</h5>
        <div class="cc">
            <div class="row mb-3">
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-muted">Entita da fatturare per questo progetto</span>
                        <button class="btn btn-success btn-sm" v-if="$root.hasFunzionalita('PROGETTO_MODIFICA')" @click="nuovaModalitaPagamento()">
                            <i class="ph-plus me-1"></i>Aggiungi
                        </button>
                    </div>

                    <div v-if="scostamentoPagamento != 0 && arrayModalitaPagamento.length > 0"
                        class="alert alert-warning mb-3">
                        <i class="ph-warning me-2"></i>
                        <strong>Attenzione:</strong>
                        <span v-if="scostamentoPagamento > 0">
                            Le modalita di pagamento (<strong>{{ formatNumber(totaleModalitaPagamento) }} €</strong>)
                            superano il totale del progetto (<strong>{{ formatNumber(totaleProgetto) }} €</strong>)
                            di <strong>{{ formatNumber(Math.abs(scostamentoPagamento)) }} €</strong>.
                        </span>
                        <span v-else>
                            Le modalita di pagamento (<strong>{{ formatNumber(totaleModalitaPagamento) }} €</strong>)
                            sono inferiori al totale del progetto (<strong>{{ formatNumber(totaleProgetto) }} €</strong>)
                            di <strong>{{ formatNumber(Math.abs(scostamentoPagamento)) }} €</strong>.
                        </span>
                    </div>

                    <div v-if="scostamentoPagamento == 0 && arrayModalitaPagamento.length > 0"
                        class="alert alert-success mb-3">
                        <i class="ph-check-circle me-2"></i>
                        La somma delle modalita di pagamento coincide con il totale del progetto
                        (<strong>{{ formatNumber(totaleProgetto) }} €</strong>).
                    </div>

                    <div v-if="arrayModalitaPagamento.length == 0" class="alert alert-info">
                        <i class="ph-info me-2"></i>Nessuna modalita di pagamento definita.
                    </div>

                    <div v-else>
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover table-sm">
                                <thead class="table-light">
                                    <tr>
                                        <th :style="$root.isGod ? 'width: 20%' : 'width: 25%'">Cliente</th>
                                        <th style="width: 20%">Codice Acquisto</th>
                                        <th style="width: 15%" class="text-end">Importo</th>
                                        <th :style="$root.isGod ? 'width: 25%' : 'width: 30%'">Note</th>
                                        <th v-if="$root.isGod" style="width: 10%" class="text-center">Attivo</th>
                                        <th style="width: 10%" class="text-center">Azioni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="mp in paginatedModalitaPagamento.arr" :key="mp.ID_MODALITA_PAGAMENTO"
                                        :class="{ 'table-secondary text-muted': mp.FLG_ATTIVO == 0 }">
                                        <td><strong>{{ mp.CLIENTE_DENOMINAZIONE }}</strong></td>
                                        <td>
                                            <span class="badge bg-info bg-opacity-20 text-info">{{ mp.CODICE_ACQUISTO || 'N/A' }}</span>
                                        </td>
                                        <td class="text-end">
                                            <strong>{{ formatNumber(parseFloat(mp.IMPORTO)) }} €</strong>
                                        </td>
                                        <td><span class="text-muted small">{{ mp.NOTE }}</span></td>
                                        <td v-if="$root.isGod" class="text-center">
                                            <ISwitch
                                                :size="'xs'"
                                                :modelValue="mp.FLG_ATTIVO"
                                                @toggle="(val) => toggleFlgAttivo(mp, val)"
                                                title="Attivo/Disattivo"
                                            ></ISwitch>
                                        </td>
                                        <td class="text-center">
                                            <a href="#" class="text-primary me-2" v-if="$root.hasFunzionalita('PROGETTO_MODIFICA')"
                                                @click.prevent="modificaModalitaPagamento(mp)">
                                                <i class="ph-pencil"></i>
                                            </a>
                                            <a href="#" class="text-danger" v-if="$root.hasFunzionalita('PROGETTO_ELIMINA')"
                                                @click.prevent="eliminaModalitaPagamento(mp)">
                                                <i class="ph-trash"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="row page-bottom">
                            <div class="col-12 col-md-5 d-none d-sm-block">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 me-2">
                                        VOCI: {{ paginatedModalitaPagamento.count }}
                                    </span>
                                    <span class="badge bg-success bg-opacity-20 text-success rounded-0 p-2">
                                        TOTALE: {{ formatNumber(totaleModalitaPagamento) }} €
                                    </span>
                                </div>
                            </div>
                            <div class="col-9 col-md-6">
                                <div class="float-end pag-mobile">
                                    <Pagine v-model="searchPagamento.PAGINATION.PAGE_NUMBER"
                                        :numrighe="paginatedModalitaPagamento.count"
                                        :numpagine="searchPagamento.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
                                </div>
                            </div>
                            <div class="col-3 col-md-1">
                                <select class="form-select form-select-sm wmin-100 mt-2 float-end"
                                    v-model="searchPagamento.PAGINATION.PAGE_SIZE"
                                    style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpModalitaPagamento' + rs" role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
                    <h6 class="modal-title">
                        <i class="ph-credit-card me-2"></i>
                        {{ modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO > 0 ? 'Modifica' : 'Nuova' }} Modalita di Pagamento
                    </h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Cliente <span class="text-danger">*</span></label>
                        <Select2 v-model="modalitaPagamentoSelezionata.FK_ID_AZIENDA" :w="250"
                            :api="'theb/s2/agenzie'"
                            :apiselected="'theb/s2/agenzie/selected?a=1'"></Select2>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Codice Acquisto</label>
                        <input type="text" class="form-control form-control-sm"
                            v-model="modalitaPagamentoSelezionata.CODICE_ACQUISTO"
                            placeholder="Inserisci il codice acquisto" />
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Importo <span class="text-danger">*</span></label>
                        <div class="input-group input-group-sm">
                            <span class="input-group-text">€</span>
                            <input type="number" step="0.01" class="form-control"
                                v-model="modalitaPagamentoSelezionata.IMPORTO" placeholder="0.00" />
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Note</label>
                        <textarea class="form-control form-control-sm" rows="2"
                            v-model="modalitaPagamentoSelezionata.NOTE" placeholder="Note..."></textarea>
                    </div>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="ph-x me-1"></i>Annulla
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary"
                        @click="salvaModalitaPagamento(false)"
                        :disabled="!modalitaPagamentoSelezionata.FK_ID_AZIENDA || !modalitaPagamentoSelezionata.IMPORTO">
                        <i class="ph-check me-1"></i>Salva e chiudi
                    </button>
                    <button v-if="modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO == 0"
                        type="button" class="btn btn-sm btn-primary"
                        @click="salvaModalitaPagamento(true)"
                        :disabled="!modalitaPagamentoSelezionata.FK_ID_AZIENDA || !modalitaPagamentoSelezionata.IMPORTO">
                        <i class="ph-check me-1"></i>Salva e continua
                    </button>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import Select2 from '@/components/utils/Select2.vue'
import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'

export default {
    name: 'TabModalitaPagamento',

    components: { Select2, Pagine, ISwitch },

    props: {
        progetto: { type: Object, required: true }
    },

    data() {
        return {
            filters: global.filters,
            rs: utils.generateRandomString(30),
            arrayModalitaPagamento: [],
            arrayTreeAttivita: [],
            modalitaPagamentoSelezionata: {
                ID_MODALITA_PAGAMENTO: 0,
                FK_ID_PROGETTO: 0,
                FK_ID_AZIENDA: 0,
                CODICE_ACQUISTO: '',
                IMPORTO: 0,
                NOTE: ''
            },
            searchPagamento: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
            }
        }
    },

    computed: {
        paginatedModalitaPagamento() {
            var arr = utils.inGrid(this.arrayModalitaPagamento, this.searchPagamento);
            return arr;
        },

        totaleModalitaPagamento() {
            var totale = 0
            for (var i = 0; i < this.arrayModalitaPagamento.length; i++) {
                totale += parseFloat(this.arrayModalitaPagamento[i].IMPORTO) || 0
            }
            return totale
        },
        totaleProgetto() {
            var totale = 0
            var sommaRicorsiva = (nodi) => {
                for (var i = 0; i < nodi.length; i++) {
                    var att = nodi[i]
                    if (att.VOCI) {
                        for (var j = 0; j < att.VOCI.length; j++) {
                            totale += parseFloat(att.VOCI[j].TOTAL_PRICE) || 0
                        }
                    }
                    if (att.SOTTO_ATTIVITA && att.SOTTO_ATTIVITA.length > 0) {
                        sommaRicorsiva(att.SOTTO_ATTIVITA)
                    }
                }
            }
            sommaRicorsiva(this.arrayTreeAttivita)
            return totale
        },
        scostamentoPagamento() {
            return Math.round((this.totaleModalitaPagamento - this.totaleProgetto) * 100) / 100
        }
    },

    methods: {
        formatNumber(n) {
            return utils.formatNumber(n);
        },

        load() {
            this.getModalitaPagamento()
            this.getTreeAttivita()
        },

        getModalitaPagamento() {
            if (this.progetto.ID_PROGETTO <= 0) {
                return
            }
            utils.ajax('theb/progetto/modalitapagamento', { ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.arrayModalitaPagamento = response.data
                }
            })
        },

        getTreeAttivita() {
            if (this.progetto.ID_PROGETTO <= 0){
                return
            } 
            utils.ajax('theb/attivita',
                { FK_ID_PROGETTO: this.progetto.ID_PROGETTO }, (response) => {
                if (response.esito == 0) {
                    this.arrayTreeAttivita = response.data
                }
            })
        },

        nuovaModalitaPagamento() {
            this.modalitaPagamentoSelezionata = {ID_MODALITA_PAGAMENTO: 0,FK_ID_PROGETTO: this.progetto.ID_PROGETTO,FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA,}
            this.filters.openPopUp('popUpModalitaPagamento' + this.rs)
        },

        modificaModalitaPagamento(mp) {
            this.modalitaPagamentoSelezionata = utils.clone(mp);
            this.filters.openPopUp('popUpModalitaPagamento' + this.rs)
        },

        salvaModalitaPagamento(continua = false) {
            if (!this.modalitaPagamentoSelezionata.FK_ID_AZIENDA || this.modalitaPagamentoSelezionata.FK_ID_AZIENDA == 0) {
                utils.alert.warning('Seleziona un cliente')
                return
            }
            if (!this.modalitaPagamentoSelezionata.IMPORTO || parseFloat(this.modalitaPagamentoSelezionata.IMPORTO) <= 0) {
                utils.alert.warning('Inserisci un importo valido')
                return
            }
            var api = this.modalitaPagamentoSelezionata.ID_MODALITA_PAGAMENTO > 0 ? 'theb/modalitapagamento/update' : 'theb/modalitapagamento/insert'
            utils.ajax(api, this.modalitaPagamentoSelezionata, (response) => {
                if (response.esito == 0) {
                    utils.alert.success('Modalita di pagamento salvata')
                    this.getModalitaPagamento()
                    if (continua) {
                        this.modalitaPagamentoSelezionata = {
                            ID_MODALITA_PAGAMENTO: 0,
                            FK_ID_PROGETTO: this.progetto.ID_PROGETTO,
                            FK_ID_AZIENDA: this.progetto.FK_ID_AZIENDA,
                        }
                    } else {
                        this.filters.closePopUp('popUpModalitaPagamento' + this.rs)
                    }
                } else {
                    utils.alert.danger(response.messaggio || 'Errore nel salvataggio')
                }
            })
        },

        eliminaModalitaPagamento(mp) {
            const isGod = this.$root.isGod;
            const confirmMsg = isGod
                ? 'Eliminare DEFINITIVAMENTE questa modalità di pagamento? Questa azione è irreversibile.'
                : 'Sicuro di voler elimnare questa modalità di pagamento?';
            const apiEndpoint = isGod ? 'theb/modalitapagamento/harddelete' : 'theb/modalitapagamento/delete';
            const successMsg = isGod ? 'Modalità di pagamento eliminata definitivamente.' : 'Modalità di pagamento eliminata con successo.';

            utils.alert.confirm(confirmMsg, () => {
                utils.ajax(apiEndpoint,
                    { ID_MODALITA_PAGAMENTO: mp.ID_MODALITA_PAGAMENTO }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(successMsg)
                        this.getModalitaPagamento()
                    }
                })
            },this.$root)
        },

        toggleFlgAttivo(mp, newValue) {
            utils.ajax('theb/modalitapagamento/update', {
                ID_MODALITA_PAGAMENTO: mp.ID_MODALITA_PAGAMENTO,
                FLG_ATTIVO: newValue
            }, (response) => {
                if (response.esito == 0) {
                    this.getModalitaPagamento()
                }
            })
        }
    }
}
</script>
